module.exports = __webpack_public_path__ + "static/media/img_group_8751.7f5bfade.webp";